import React from "react";

///////////////////Desktop
import HeaderComponent from "../../structure_components/desktop_screens/header_component/header_component";
// import PyqCpsExamComponent from "./PyqCpsExamContentComponent/PyqCpsExamContentComponent";
//////Mobile////////////////////
import MobileLeftSideBarComponent from "../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import MobileHeaderComponent from "../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileRightSideBarComponent from "../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import LoaderPopUp from "../../../../components/loader/loader";
import { connect } from "react-redux";
import WalletContentComponent from "./WalletContentComponent/WalletContentComponent";
import Footer_component from "../../structure_components/desktop_screens/footer_component/Footer_component";

const Wallet = (props) => {
  let { history, loader, userData, userPreference, location } = props;
  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <>
      <div className="walletWrapper">
        <div className="walletInrWrapper">
          {isMob() ? (
            <>
              <MobileLeftSideBarComponent />
              <MobileHeaderComponent
                userPreference={userPreference}
                userData={userData}
              />
              <MobileRightSideBarComponent history={history} />
            </>
          ) : (
            <HeaderComponent history={history} />
          )}
          <WalletContentComponent
            history={history}
            userData={userData}
            userPreference={userPreference}
            location={location}
          />
        </div>
        <Footer_component />
      </div>
      {loader && <LoaderPopUp />}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};
export default connect(mapStateToProps)(Wallet);
